























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Decklist } from '@/types/decklist';

@Component({
  components: {
  },
})
export default class CardStackFooter extends Vue {
  private showCopy = false;

  get disableCopy(): boolean {
    return !(!!this.$store.state.sets && this.$store.state.sets.length > 0);
  }
  get decklist(): Decklist {
    return this.$store.state.decklist.decklist;
  }

  private copyToClipboard() {
    this.showCopy = true;
    this.$emit('copyToClipboard');
    setTimeout(() => this.showCopy = false, 1500);
  }

  private delay2(el: any) {
    setTimeout(() => { el.hide(true); }, 2000);
  }
}
